<template>
  <svg :class="svgClass" :style="svgStyle">
    <!-- Important de garder href et xlink href: 
    problème de compatibilité avec certaines versions de navigateurs -->
    <use :xlink:href="name" :href="name" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    prefix: {
      type: String,
      default: 'icon',
    },
    iconName: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      default: '',
    },
  },

  computed: {
    name() {
      const icon = this.iconName;
      return icon ? `#${this.prefix}-${this.iconName}` : '';
    },
    svgClass() {
      const { className } = this;
      return className ? `svg-icon ${className}` : 'svg-icon';
    },
    svgStyle() {
      if (this.color) {
        return {
          color: this.color,
        };
      }

      return {};
    },
  },
};
</script>

<style>
.svg-icon {
  width: 1em;
  height: 1em;
  overflow: hidden;
}
</style>
